export const outdatedVersionError = 'outdatedVersion'
export const invalidSemverError = 'invalidSemver'
export const notSupportedOSError = 'notSupportedOS'
